import { render, staticRenderFns } from "./paperCheckManage.vue?vue&type=template&id=db15853a&scoped=true"
import script from "./paperCheckManage.vue?vue&type=script&lang=js"
export * from "./paperCheckManage.vue?vue&type=script&lang=js"
import style0 from "./paperCheckManage.vue?vue&type=style&index=0&id=db15853a&prod&scoped=true&lang=less"
import style1 from "./paperCheckManage.vue?vue&type=style&index=1&id=db15853a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db15853a",
  null
  
)

export default component.exports